webpackJsonp([35783957827783],{

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CodeExample = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var highlightGraphQL = function highlightGraphQL(code) {
	  var keywords = ['query', 'mutation', 'subscription', 'fragment', 'on', 'type', 'interface', 'enum', 'union', 'scalar', 'input', 'extend', 'implements'];
	
	  var lines = code.split('\n');
	
	  return lines.map(function (line, lineIndex) {
	    var tokens = [];
	    var currentPos = 0;
	    var remainingLine = line;
	
	    // Process the line token by token
	    while (remainingLine.length > 0) {
	      var matched = false;
	
	      // Check for comment
	      var commentMatch = remainingLine.match(/^(#.*)/);
	      if (commentMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'comment' },
	          commentMatch[1]
	        ));
	        break;
	      }
	
	      // Check for string
	      var stringMatch = remainingLine.match(/^("(?:[^"\\]|\\.)*")/);
	      if (stringMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'string' },
	          stringMatch[1]
	        ));
	        remainingLine = remainingLine.slice(stringMatch[1].length);
	        currentPos += stringMatch[1].length;
	        matched = true;
	        continue;
	      }
	
	      // Check for variable
	      var varMatch = remainingLine.match(/^(\$\w+)/);
	      if (varMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'variable' },
	          varMatch[1]
	        ));
	        remainingLine = remainingLine.slice(varMatch[1].length);
	        currentPos += varMatch[1].length;
	        matched = true;
	        continue;
	      }
	
	      // Check for keyword
	      var keywordMatched = false;
	      for (var _iterator = keywords, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var keyword = _ref;
	
	        var keywordRegex = new RegExp('^(' + keyword + ')\\b');
	        var keywordMatch = remainingLine.match(keywordRegex);
	        if (keywordMatch) {
	          tokens.push(_react2.default.createElement(
	            'span',
	            { key: lineIndex + '-' + currentPos, className: 'keyword' },
	            keywordMatch[1]
	          ));
	          remainingLine = remainingLine.slice(keywordMatch[1].length);
	          currentPos += keywordMatch[1].length;
	          keywordMatched = true;
	          matched = true;
	          break;
	        }
	      }
	      if (keywordMatched) continue;
	
	      // Check for field name (word before { or ()
	      var fieldMatch = remainingLine.match(/^(\w+)(?=\s*[{(])/);
	      if (fieldMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'function' },
	          fieldMatch[1]
	        ));
	        remainingLine = remainingLine.slice(fieldMatch[1].length);
	        currentPos += fieldMatch[1].length;
	        matched = true;
	        continue;
	      }
	
	      // No special token, just take one character
	      tokens.push(_react2.default.createElement(
	        'span',
	        { key: lineIndex + '-' + currentPos },
	        remainingLine[0]
	      ));
	      remainingLine = remainingLine.slice(1);
	      currentPos += 1;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { key: lineIndex },
	      tokens
	    );
	  });
	};
	
	var highlightJSON = function highlightJSON(code) {
	  var lines = code.split('\n');
	
	  return lines.map(function (line, lineIndex) {
	    var tokens = [];
	    var remainingLine = line;
	    var currentPos = 0;
	
	    while (remainingLine.length > 0) {
	      // Check for property name (string before colon)
	      var propMatch = remainingLine.match(/^(\s*)"([^"]+)"(\s*:)/);
	      if (propMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos + '-ws' },
	          propMatch[1]
	        ));
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'property' },
	          '"',
	          propMatch[2],
	          '"'
	        ));
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos + '-colon' },
	          propMatch[3]
	        ));
	        remainingLine = remainingLine.slice(propMatch[0].length);
	        currentPos += propMatch[0].length;
	        continue;
	      }
	
	      // Check for string value
	      var stringMatch = remainingLine.match(/^("(?:[^"\\]|\\.)*")/);
	      if (stringMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'string' },
	          stringMatch[1]
	        ));
	        remainingLine = remainingLine.slice(stringMatch[1].length);
	        currentPos += stringMatch[1].length;
	        continue;
	      }
	
	      // Check for number
	      var numMatch = remainingLine.match(/^(-?\d+\.?\d*)/);
	      if (numMatch && remainingLine[0].match(/[\d-]/)) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'number' },
	          numMatch[1]
	        ));
	        remainingLine = remainingLine.slice(numMatch[1].length);
	        currentPos += numMatch[1].length;
	        continue;
	      }
	
	      // Check for boolean/null
	      var boolMatch = remainingLine.match(/^(true|false|null)\b/);
	      if (boolMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'keyword' },
	          boolMatch[1]
	        ));
	        remainingLine = remainingLine.slice(boolMatch[1].length);
	        currentPos += boolMatch[1].length;
	        continue;
	      }
	
	      // Regular character
	      tokens.push(_react2.default.createElement(
	        'span',
	        { key: lineIndex + '-' + currentPos },
	        remainingLine[0]
	      ));
	      remainingLine = remainingLine.slice(1);
	      currentPos += 1;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { key: lineIndex },
	      tokens
	    );
	  });
	};
	
	var highlightBash = function highlightBash(code) {
	  var lines = code.split('\n');
	  var commands = ['curl', 'echo', 'cat', 'grep', 'awk', 'sed', 'node', 'npm', 'yarn', 'git', 'docker', 'cd', 'ls', 'mkdir', 'rm', 'cp', 'mv'];
	
	  return lines.map(function (line, lineIndex) {
	    var tokens = [];
	    var remainingLine = line;
	    var currentPos = 0;
	    var isStartOfLine = true;
	
	    while (remainingLine.length > 0) {
	      // Check for comment
	      var commentMatch = remainingLine.match(/^(#.*)/);
	      if (commentMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'comment' },
	          commentMatch[1]
	        ));
	        break;
	      }
	
	      // Check for string
	      var stringMatch = remainingLine.match(/^(["'](?:[^"'\\]|\\.)*["'])/);
	      if (stringMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'string' },
	          stringMatch[1]
	        ));
	        remainingLine = remainingLine.slice(stringMatch[1].length);
	        currentPos += stringMatch[1].length;
	        isStartOfLine = false;
	        continue;
	      }
	
	      // Check for command at start
	      if (isStartOfLine || remainingLine.match(/^\s/)) {
	        var wsMatch = remainingLine.match(/^(\s+)/);
	        if (wsMatch) {
	          tokens.push(_react2.default.createElement(
	            'span',
	            { key: lineIndex + '-' + currentPos },
	            wsMatch[1]
	          ));
	          remainingLine = remainingLine.slice(wsMatch[1].length);
	          currentPos += wsMatch[1].length;
	          continue;
	        }
	
	        for (var _iterator2 = commands, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	          var _ref2;
	
	          if (_isArray2) {
	            if (_i2 >= _iterator2.length) break;
	            _ref2 = _iterator2[_i2++];
	          } else {
	            _i2 = _iterator2.next();
	            if (_i2.done) break;
	            _ref2 = _i2.value;
	          }
	
	          var cmd = _ref2;
	
	          var cmdMatch = remainingLine.match(new RegExp('^(' + cmd + ')\\b'));
	          if (cmdMatch) {
	            tokens.push(_react2.default.createElement(
	              'span',
	              { key: lineIndex + '-' + currentPos, className: 'keyword' },
	              cmdMatch[1]
	            ));
	            remainingLine = remainingLine.slice(cmdMatch[1].length);
	            currentPos += cmdMatch[1].length;
	            isStartOfLine = false;
	            continue;
	          }
	        }
	      }
	
	      // Check for flags
	      var flagMatch = remainingLine.match(/^(-+[\w-]+)/);
	      if (flagMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'variable' },
	          flagMatch[1]
	        ));
	        remainingLine = remainingLine.slice(flagMatch[1].length);
	        currentPos += flagMatch[1].length;
	        continue;
	      }
	
	      // Regular character
	      tokens.push(_react2.default.createElement(
	        'span',
	        { key: lineIndex + '-' + currentPos },
	        remainingLine[0]
	      ));
	      remainingLine = remainingLine.slice(1);
	      currentPos += 1;
	      isStartOfLine = false;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { key: lineIndex },
	      tokens
	    );
	  });
	};
	
	var CodeExample = exports.CodeExample = function CodeExample(_ref3) {
	  var title = _ref3.title,
	      code = _ref3.code,
	      _ref3$language = _ref3.language,
	      language = _ref3$language === undefined ? "graphql" : _ref3$language;
	
	  var _useState = (0, _react.useState)(false),
	      copied = _useState[0],
	      setCopied = _useState[1];
	
	  var handleCopy = function handleCopy() {
	    navigator.clipboard.writeText(code);
	    setCopied(true);
	    setTimeout(function () {
	      return setCopied(false);
	    }, 2000);
	  };
	
	  var renderHighlighted = function renderHighlighted() {
	    switch (language) {
	      case 'graphql':
	        return highlightGraphQL(code);
	      case 'json':
	        return highlightJSON(code);
	      case 'bash':
	        return highlightBash(code);
	      default:
	        return code;
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'code-example' },
	    title && _react2.default.createElement(
	      'div',
	      { className: 'code-example-title' },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'code-example-container' },
	      _react2.default.createElement(
	        'button',
	        {
	          className: 'code-example-copy-btn',
	          onClick: handleCopy,
	          'aria-label': 'Copy code'
	        },
	        copied ? "✓ Copied!" : "Copy"
	      ),
	      _react2.default.createElement(
	        'pre',
	        { className: 'code-example-pre' },
	        _react2.default.createElement(
	          'code',
	          { className: 'language-' + language },
	          renderHighlighted()
	        )
	      )
	    )
	  );
	};

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.BookOpenIcon = exports.EnvelopeIcon = exports.LightBulbIcon = exports.BoltIcon = exports.DocumentTextIcon = exports.LockClosedIcon = exports.RocketLaunchIcon = exports.MoonIcon = exports.SunIcon = exports.VariableIcon = exports.TagIcon = exports.ArrowDownTrayIcon = exports.LinkIcon = exports.CubeIcon = exports.PencilSquareIcon = exports.MagnifyingGlassIcon = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Heroicons (16x16 rendered, 24x24 viewBox)
	
	var MagnifyingGlassIcon = exports.MagnifyingGlassIcon = function MagnifyingGlassIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("circle", { cx: "11", cy: "11", r: "8" }),
	    _react2.default.createElement("path", { d: "m21 21-4.35-4.35" })
	  );
	};
	
	var PencilSquareIcon = exports.PencilSquareIcon = function PencilSquareIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("path", { d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" })
	  );
	};
	
	var CubeIcon = exports.CubeIcon = function CubeIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("path", { d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" }),
	    _react2.default.createElement("polyline", { points: "3.27 6.96 12 12.01 20.73 6.96" }),
	    _react2.default.createElement("line", { x1: "12", y1: "22.08", x2: "12", y2: "12" })
	  );
	};
	
	var LinkIcon = exports.LinkIcon = function LinkIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
	    _react2.default.createElement("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
	  );
	};
	
	var ArrowDownTrayIcon = exports.ArrowDownTrayIcon = function ArrowDownTrayIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("path", { d: "M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" })
	  );
	};
	
	var TagIcon = exports.TagIcon = function TagIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("path", { d: "M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z" }),
	    _react2.default.createElement("path", { d: "M6 6h.008v.008H6V6z" })
	  );
	};
	
	var VariableIcon = exports.VariableIcon = function VariableIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("path", { d: "M9 4v16" }),
	    _react2.default.createElement("path", { d: "M15 4v16" }),
	    _react2.default.createElement("path", { d: "M4 9h16" }),
	    _react2.default.createElement("path", { d: "M4 15h16" })
	  );
	};
	
	var SunIcon = exports.SunIcon = function SunIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("circle", { cx: "12", cy: "12", r: "4" }),
	    _react2.default.createElement("path", { d: "M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" })
	  );
	};
	
	var MoonIcon = exports.MoonIcon = function MoonIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("path", { d: "M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" })
	  );
	};
	
	// Additional icons (24x24 rendered, 24x24 viewBox)
	var RocketLaunchIcon = exports.RocketLaunchIcon = function RocketLaunchIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("path", { d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" }),
	    _react2.default.createElement("path", { d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" }),
	    _react2.default.createElement("path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" }),
	    _react2.default.createElement("path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" })
	  );
	};
	
	var LockClosedIcon = exports.LockClosedIcon = function LockClosedIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2" }),
	    _react2.default.createElement("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
	  );
	};
	
	var DocumentTextIcon = exports.DocumentTextIcon = function DocumentTextIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
	    _react2.default.createElement("polyline", { points: "14,2 14,8 20,8" }),
	    _react2.default.createElement("line", { x1: "16", y1: "13", x2: "8", y2: "13" }),
	    _react2.default.createElement("line", { x1: "16", y1: "17", x2: "8", y2: "17" }),
	    _react2.default.createElement("polyline", { points: "10,9 9,9 8,9" })
	  );
	};
	
	var BoltIcon = exports.BoltIcon = function BoltIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("polygon", { points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2" })
	  );
	};
	
	var LightBulbIcon = exports.LightBulbIcon = function LightBulbIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("path", { d: "M9 21h6" }),
	    _react2.default.createElement("path", { d: "M12 3a6 6 0 0 0-6 6v1a2 2 0 0 0 .5 1.3L8 13h8l1.5-1.7a2 2 0 0 0 .5-1.3V9a6 6 0 0 0-6-6Z" })
	  );
	};
	
	var EnvelopeIcon = exports.EnvelopeIcon = function EnvelopeIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }),
	    _react2.default.createElement("path", { d: "m22 7-10 5L2 7" })
	  );
	};
	
	var BookOpenIcon = exports.BookOpenIcon = function BookOpenIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" }),
	    _react2.default.createElement("path", { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" })
	  );
	};

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CodeExample = __webpack_require__(28);
	
	var _Icons = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(props) {
	  var _useState = (0, _react.useState)(false),
	      darkMode = _useState[0],
	      setDarkMode = _useState[1];
	
	  (0, _react.useEffect)(function () {
	    var checkDarkMode = function checkDarkMode() {
	      setDarkMode(document.body.classList.contains("dark-mode"));
	    };
	
	    // Check initial state
	    checkDarkMode();
	
	    // Watch for changes
	    var observer = new MutationObserver(checkDarkMode);
	    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
	
	    return function () {
	      return observer.disconnect();
	    };
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "page" },
	    _react2.default.createElement(
	      "section",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "section-text" },
	        _react2.default.createElement(
	          "h1",
	          { className: "main-heading", style: { fontSize: "3.2rem", fontWeight: "700", marginBottom: "16px" } },
	          "Build Amazing Veterinary Software with Vetspire API"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "main-description", style: { fontSize: "1.8rem", marginBottom: "24px", lineHeight: "1.6" } },
	          "The modern GraphQL API for veterinary practice management. Connect your applications to client records, patient data, appointments, billing, and more with type-safe, flexible queries that return exactly the data you need."
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "intro-card intro-special", style: {
	              backgroundColor: darkMode ? "#21262d" : "#f7fafc",
	              border: "1px solid " + (darkMode ? "#30363d" : "#e2e8f0"),
	              borderRadius: "8px",
	              padding: "20px",
	              marginBottom: "24px"
	            } },
	          _react2.default.createElement(
	            "h3",
	            { style: { marginTop: "0", marginBottom: "12px", display: "flex", alignItems: "center", gap: "8px" } },
	            _react2.default.createElement(_Icons.RocketLaunchIcon, null),
	            " What makes Vetspire API special?"
	          ),
	          _react2.default.createElement(
	            "ul",
	            { style: { marginBottom: "0", paddingLeft: "20px" } },
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "GraphQL-first:"
	              ),
	              " Fetch exactly what you need in a single request"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Veterinary-focused:"
	              ),
	              " Purpose-built for animal healthcare workflows"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Real-time:"
	              ),
	              " Support for subscriptions and live data updates"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Type-safe:"
	              ),
	              " Complete TypeScript definitions and schema introspection"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Built on the powerful",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "http://graphql.org/", target: "_blank", rel: "noopener noreferrer" },
	            "GraphQL specification"
	          ),
	          ", our API gives you the flexibility to request precisely the data your application needs. Whether you're building a mobile app, web dashboard, or integrating with existing systems, Vetspire API adapts to your requirements."
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: {
	              display: "grid",
	              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
	              gap: "16px",
	              marginTop: "24px",
	              marginBottom: "24px"
	            } },
	          _react2.default.createElement(
	            "div",
	            { className: "intro-card", style: {
	                border: "1px solid " + (darkMode ? "#30363d" : "#e2e8f0"),
	                borderRadius: "8px",
	                padding: "16px",
	                backgroundColor: darkMode ? "#161b22" : "#ffffff"
	              } },
	            _react2.default.createElement(
	              "div",
	              { style: { color: "#10b981", marginBottom: "8px", display: "flex" } },
	              _react2.default.createElement(_Icons.LockClosedIcon, null)
	            ),
	            _react2.default.createElement(
	              "h4",
	              { style: { margin: "0 0 8px 0" } },
	              "Secure by Design"
	            ),
	            _react2.default.createElement(
	              "p",
	              { style: { margin: "0", fontSize: "1.4rem" } },
	              "Enterprise-grade security with API key authentication and environment isolation."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "intro-card", style: {
	                border: "1px solid " + (darkMode ? "#30363d" : "#e2e8f0"),
	                borderRadius: "8px",
	                padding: "16px",
	                backgroundColor: darkMode ? "#161b22" : "#ffffff"
	              } },
	            _react2.default.createElement(
	              "div",
	              { style: { color: "#f59e0b", marginBottom: "8px", display: "flex" } },
	              _react2.default.createElement(_Icons.DocumentTextIcon, null)
	            ),
	            _react2.default.createElement(
	              "h4",
	              { style: { margin: "0 0 8px 0" } },
	              "Rich Documentation"
	            ),
	            _react2.default.createElement(
	              "p",
	              { style: { margin: "0", fontSize: "1.4rem" } },
	              "Interactive examples, comprehensive type definitions, and real-world use cases."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "intro-card", style: {
	                border: "1px solid " + (darkMode ? "#30363d" : "#e2e8f0"),
	                borderRadius: "8px",
	                padding: "16px",
	                backgroundColor: darkMode ? "#161b22" : "#ffffff"
	              } },
	            _react2.default.createElement(
	              "div",
	              { style: { color: "#8b5cf6", marginBottom: "8px", display: "flex" } },
	              _react2.default.createElement(_Icons.BoltIcon, null)
	            ),
	            _react2.default.createElement(
	              "h4",
	              { style: { margin: "0 0 8px 0" } },
	              "Developer Experience"
	            ),
	            _react2.default.createElement(
	              "p",
	              { style: { margin: "0", fontSize: "1.4rem" } },
	              "Multiple environments, helpful error messages, and extensive tooling support."
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "important" },
	          "Stay informed about API updates by subscribing to our",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://groups.google.com/forum/#!forum/vetspire-api-announce" },
	            "developer announcement mailing list"
	          ),
	          ". We'll notify you about new features, breaking changes, and best practices."
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Get Started"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", gap: "12px", flexWrap: "wrap", marginTop: "16px" } },
	          _react2.default.createElement(
	            "a",
	            { href: "https://groups.google.com/forum/#!forum/vetspire-api-announce",
	              target: "_blank",
	              rel: "noopener noreferrer",
	              style: {
	                padding: "12px 20px",
	                backgroundColor: "#4d65ff",
	                color: "white",
	                borderRadius: "6px",
	                textDecoration: "none",
	                fontWeight: "600",
	                display: "inline-flex",
	                alignItems: "center",
	                gap: "8px",
	                transition: "all 0.2s ease"
	              },
	              onMouseEnter: function onMouseEnter(e) {
	                return e.target.style.backgroundColor = "#3a4dd4";
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                return e.target.style.backgroundColor = "#4d65ff";
	              } },
	            _react2.default.createElement(_Icons.EnvelopeIcon, null),
	            " Subscribe to Updates"
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "http://graphql.org/learn/",
	              target: "_blank",
	              rel: "noopener noreferrer",
	              style: {
	                padding: "12px 20px",
	                backgroundColor: "white",
	                color: "#4d65ff",
	                borderRadius: "6px",
	                textDecoration: "none",
	                fontWeight: "600",
	                border: "2px solid #4d65ff",
	                display: "inline-flex",
	                alignItems: "center",
	                gap: "8px",
	                transition: "all 0.2s ease"
	              },
	              onMouseEnter: function onMouseEnter(e) {
	                e.target.style.backgroundColor = "#4d65ff";
	                e.target.style.color = "white";
	              },
	              onMouseLeave: function onMouseLeave(e) {
	                e.target.style.backgroundColor = "white";
	                e.target.style.color = "#4d65ff";
	              } },
	            _react2.default.createElement(_Icons.BookOpenIcon, null),
	            " Learn GraphQL"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "section-example on" },
	        _react2.default.createElement(
	          "div",
	          { className: "section-example-area" },
	          _react2.default.createElement(
	            "div",
	            { style: { marginBottom: "8px", fontSize: "1.4rem", fontWeight: "600" } },
	            "API ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Production"
	            ),
	            " Endpoint"
	          ),
	          _react2.default.createElement(
	            "pre",
	            null,
	            "https://api.vetspire.com/graphql"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "section-example-area" },
	          _react2.default.createElement(
	            "div",
	            { style: { marginBottom: "8px", fontSize: "1.4rem", fontWeight: "600" } },
	            "API ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Testing"
	            ),
	            " Endpoint"
	          ),
	          _react2.default.createElement(
	            "pre",
	            null,
	            "https://api.staging.vetspire.com/graphql"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "section-example-area" },
	          _react2.default.createElement(
	            "div",
	            { style: { marginBottom: "8px", fontSize: "1.4rem", fontWeight: "600" } },
	            "API ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Sandbox"
	            ),
	            " Endpoint"
	          ),
	          _react2.default.createElement(
	            "pre",
	            null,
	            "https://api.sandbox.vetspire.com/graphql"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "section-text" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Authentication"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Every request made to our API Endpoint must include an Authorization header which includes your secret API Key. Your secret API Key enables read and write access to your entire organization's data, so keep it safe and secret! It should be treated equivalently to an administrator's password. Your API Key should never be shared in public spaces. You should take extra precaution to ensure that your API keys are never committed to your public git repositories."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "On your administrator dashboard, you'll be able to generate API keys for both testing and production use. You can revoke old keys and generate new ones at any time."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "For every request made to the API, you should include the API Key in the header of your HTTPS request under \"Authorization\". Any request made without a valid Authorization header will return a",
	          " ",
	          _react2.default.createElement(
	            "code",
	            null,
	            "403"
	          ),
	          " error response. See an example using",
	          " ",
	          _react2.default.createElement(
	            "code",
	            null,
	            "curl"
	          ),
	          " on the right. Furthermore, all API requests must be made over HTTPS."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Every GraphQL request is replied with by a valid JSON string that represents the data being fetched or any errors incurred in the fetching (e.g. if you are unauthorized to access the data being requested)."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Getting Started with Your First Query"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "The easiest way to get started is by querying your organization information. This simple query will help you verify that your API key is working correctly and give you basic information about your Vetspire organization."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "All you need to do is make a POST request to the API endpoint with your query and include your API key in the Authorization header."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Limits"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "We currently enforce a maximum query depth of 8. If you exceed this, you'll see the an error code ",
	          _react2.default.createElement(
	            "code",
	            null,
	            "query_depth_limit"
	          ),
	          " with a message: Query has depth of 9, which exceeds max depth of 8. This limit helps us ensure we can provide a reliable service to all API users."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "If you run into this error, please split up your query into multiple smaller queries or reconsider whether you need all the information you requested."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "section-example on" },
	        _react2.default.createElement(
	          "div",
	          { className: "section-example-area" },
	          _react2.default.createElement(_CodeExample.CodeExample, {
	            title: "Your First GraphQL Query",
	            code: "query GetOrganization {\n  org {\n    id\n    name\n  }\n}",
	            language: "graphql"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "section-example-area" },
	          _react2.default.createElement(_CodeExample.CodeExample, {
	            title: "cURL Request",
	            code: "curl https://api.staging.vetspire.com/graphql \\\n  -X POST \\\n  -H \"Authorization: YOUR_API_KEY\" \\\n  -H \"Content-Type: application/json\" \\\n  -d '{\"query\": \"query GetOrganization { org { id name } }\"}'",
	            language: "bash"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "section-example-area" },
	          _react2.default.createElement(_CodeExample.CodeExample, {
	            title: "Example Response",
	            code: "{\n  \"data\": {\n    \"org\": {\n      \"id\": \"1\",\n      \"name\": \"Your Clinic Name\"\n    }\n  }\n}",
	            language: "json"
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "section-text" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Exploring the API Reference"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Our comprehensive API reference is organized by veterinary practice domains, making it easy to find the functionality you need. Use the sidebar navigation to explore different areas of the API."
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: {
	              display: "flex",
	              gap: "24px",
	              marginTop: "24px",
	              marginBottom: "24px",
	              alignItems: "flex-start"
	            } },
	          _react2.default.createElement(
	            "div",
	            { style: {
	                flex: 1,
	                backgroundColor: darkMode ? "#161b22" : "#ffffff",
	                border: "1px solid " + (darkMode ? "#30363d" : "#e2e8f0"),
	                borderRadius: "8px",
	                padding: "20px",
	                borderTop: "3px solid #10b981"
	              } },
	            _react2.default.createElement(
	              "h4",
	              { style: { color: "#10b981", margin: "0 0 12px 0", display: "flex", alignItems: "center", gap: "8px" } },
	              _react2.default.createElement(_Icons.MagnifyingGlassIcon, null),
	              " ",
	              _react2.default.createElement(
	                "span",
	                null,
	                "Queries"
	              )
	            ),
	            _react2.default.createElement(
	              "p",
	              { style: { margin: "0 0 8px 0", fontSize: "1.4rem" } },
	              "Fetch data from your practice management system:"
	            ),
	            _react2.default.createElement(
	              "ul",
	              { style: { fontSize: "1.3rem", color: "#718096", paddingLeft: "20px" } },
	              _react2.default.createElement(
	                "li",
	                null,
	                "Client and patient information"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "Appointment schedules"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "Medical records and encounters"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "Billing and invoices"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "Inventory management"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: {
	                flex: 1,
	                backgroundColor: darkMode ? "#161b22" : "#ffffff",
	                border: "1px solid " + (darkMode ? "#30363d" : "#e2e8f0"),
	                borderRadius: "8px",
	                padding: "20px",
	                borderTop: "3px solid #f59e0b"
	              } },
	            _react2.default.createElement(
	              "h4",
	              { style: { color: "#f59e0b", margin: "0 0 12px 0", display: "flex", alignItems: "center", gap: "8px" } },
	              _react2.default.createElement(_Icons.PencilSquareIcon, null),
	              " ",
	              _react2.default.createElement(
	                "span",
	                null,
	                "Mutations"
	              )
	            ),
	            _react2.default.createElement(
	              "p",
	              { style: { margin: "0 0 8px 0", fontSize: "1.4rem" } },
	              "Create, update, and manage practice data:"
	            ),
	            _react2.default.createElement(
	              "ul",
	              { style: { fontSize: "1.3rem", color: "#718096", paddingLeft: "20px" } },
	              _react2.default.createElement(
	                "li",
	                null,
	                "Schedule appointments"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "Update patient records"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "Process payments"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "Manage treatments"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "Handle communications"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "pro-tips-section", style: {
	              backgroundColor: darkMode ? "#0d1117" : "#f0f9ff",
	              border: "1px solid " + (darkMode ? "#1f6feb" : "#0ea5e9"),
	              borderRadius: "8px",
	              padding: "20px",
	              marginTop: "24px"
	            } },
	          _react2.default.createElement(
	            "h4",
	            { style: { margin: "0 0 12px 0", display: "flex", alignItems: "center", gap: "8px" } },
	            _react2.default.createElement(_Icons.LightBulbIcon, null),
	            " ",
	            _react2.default.createElement(
	              "span",
	              null,
	              "Pro Tips for Navigation"
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            { style: { margin: "0", paddingLeft: "20px" } },
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Use the search (\u2318K):"
	              ),
	              " Quickly find queries, mutations, or types"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Organized by domain:"
	              ),
	              " Related operations are grouped together (e.g., Clinical, Billing)"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Detailed descriptions:"
	              ),
	              " Each field includes context-aware descriptions"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Type system:"
	              ),
	              " Explore object types, enums, and input objects in the sidebar"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Understanding GraphQL Syntax"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Each operation in our API follows GraphQL conventions. Here's how to read the reference documentation:"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "graphql-syntax-section", style: {
	              backgroundColor: darkMode ? "#21262d" : "#fafafa",
	              border: "1px solid " + (darkMode ? "#30363d" : "#e5e7eb"),
	              borderRadius: "8px",
	              padding: "20px",
	              marginTop: "16px"
	            } },
	          _react2.default.createElement(
	            "h4",
	            { style: { margin: "0 0 12px 0", fontFamily: "monospace" } },
	            "getClients(active: Boolean, limit: Int!): [Client]"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { fontSize: "1.4rem" } },
	            _react2.default.createElement(
	              "p",
	              { style: { margin: "0 0 8px 0" } },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "getClients"
	              ),
	              " - The operation name"
	            ),
	            _react2.default.createElement(
	              "p",
	              { style: { margin: "0 0 8px 0" } },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "active: Boolean"
	              ),
	              " - Optional parameter (no exclamation mark)"
	            ),
	            _react2.default.createElement(
	              "p",
	              { style: { margin: "0 0 8px 0" } },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "limit: Int!"
	              ),
	              " - Required parameter (exclamation mark)"
	            ),
	            _react2.default.createElement(
	              "p",
	              { style: { margin: "0" } },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "[Client]"
	              ),
	              " - Returns an array of Client objects"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "section-example on" },
	        _react2.default.createElement(
	          "div",
	          { style: {
	              padding: "20px",
	              backgroundColor: darkMode ? "#0d1117" : "#1a202c",
	              borderRadius: "6px",
	              fontSize: "1.4rem",
	              lineHeight: "1.6",
	              color: "#e2e8f0"
	            } },
	          _react2.default.createElement(
	            "p",
	            { style: { margin: "0 0 16px 0", fontWeight: "600", color: "#63b3ed" } },
	            "GraphQL Type Notation:"
	          ),
	          _react2.default.createElement(
	            "p",
	            { style: { margin: "0 0 8px 0" } },
	            _react2.default.createElement(
	              "code",
	              { style: {
	                  backgroundColor: darkMode ? "#21262d" : "#2d3748",
	                  color: "#68d391",
	                  padding: "4px 8px",
	                  borderRadius: "4px",
	                  fontWeight: "600"
	                } },
	              "String"
	            ),
	            " - A text value"
	          ),
	          _react2.default.createElement(
	            "p",
	            { style: { margin: "0 0 8px 0" } },
	            _react2.default.createElement(
	              "code",
	              { style: {
	                  backgroundColor: darkMode ? "#21262d" : "#2d3748",
	                  color: "#f56565",
	                  padding: "4px 8px",
	                  borderRadius: "4px",
	                  fontWeight: "600"
	                } },
	              "String!"
	            ),
	            " - A required text value"
	          ),
	          _react2.default.createElement(
	            "p",
	            { style: { margin: "0 0 8px 0" } },
	            _react2.default.createElement(
	              "code",
	              { style: {
	                  backgroundColor: darkMode ? "#21262d" : "#2d3748",
	                  color: "#9f7aea",
	                  padding: "4px 8px",
	                  borderRadius: "4px",
	                  fontWeight: "600"
	                } },
	              "[String]"
	            ),
	            " - An array of text values"
	          ),
	          _react2.default.createElement(
	            "p",
	            { style: { margin: "0" } },
	            _react2.default.createElement(
	              "code",
	              { style: {
	                  backgroundColor: darkMode ? "#21262d" : "#2d3748",
	                  color: "#ed8936",
	                  padding: "4px 8px",
	                  borderRadius: "4px",
	                  fontWeight: "600"
	                } },
	              "[String!]!"
	            ),
	            " - A required array of required text values"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-8daa0b7d678cdfa019c1.js